import api from '@pray/shared/utils/api';

export type AddSpendRampParams = {
  artistId: string;
  campaignId: string;
  name?: string;
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
  dailyBudgetCents: number;
  reason?: string;
};

export const addSpendRamp = async ({
  artistId,
  campaignId,
  name,
  startDate,
  endDate,
  dailyBudgetCents,
  reason,
}: AddSpendRampParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/spend-ramps`;

  const body: Record<string, unknown> = {
    start_date: startDate,
    end_date: endDate,
    daily_budget_cents: dailyBudgetCents,
  };

  if (name) body.name = name;
  if (reason) body.reason = reason;

  const response = await api.executePostRequest(url, body);

  return response.data;
};
